import * as React from "react";
const SvgFiRrToDoAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-to-do-alt_svg__a)">
      <path
        fill="#062147"
        d="M12 2h-.171A3.01 3.01 0 0 0 9 0H7a3.01 3.01 0 0 0-2.829 2H4C1.794 2 0 3.794 0 6v13c0 2.757 2.243 5 5 5h6c2.757 0 5-2.243 5-5V6c0-2.206-1.794-4-4-4m2 17c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V6c0-1.103.897-2 2-2h1a1 1 0 0 0 1-1 1 1 0 0 1 1-1h2a1 1 0 0 1 1 1 1 1 0 0 0 1 1h1c1.103 0 2 .897 2 2zm7-19c-1.654 0-3 1.346-3 3v16.343c0 1.336.521 2.592 1.465 3.536l.828.828a.997.997 0 0 0 1.414 0l.828-.828A4.97 4.97 0 0 0 24 19.343V3c0-1.654-1.346-3-3-3m1 19.343c0 .802-.313 1.556-.879 2.122l-.121.121-.121-.121A2.98 2.98 0 0 1 20 19.343V3a1 1 0 0 1 2 0zM9.727 6.793a1 1 0 0 1 0 1.414l-2.179 2.179a2.1 2.1 0 0 1-1.483.613 2.1 2.1 0 0 1-1.483-.613L3.294 9.097a.999.999 0 1 1 1.414-1.414l1.288 1.289c.033.033.105.033.139 0l2.179-2.179a1 1 0 0 1 1.413 0m0 6a1 1 0 0 1 0 1.414l-2.179 2.179a2.1 2.1 0 0 1-1.483.613 2.1 2.1 0 0 1-1.483-.613l-1.288-1.289a.999.999 0 1 1 1.414-1.414l1.288 1.289c.033.033.105.033.139 0l2.179-2.179a1 1 0 0 1 1.413 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-to-do-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrToDoAlt;
